<template>
<div>
  {{assets}}
</div>
</template>

<script>
export default {
  name: "MyCustomer",
  props: {
    assets: {
      type: String,
      default: 'a',
      required: false
    }
  },
}
</script>

<style scoped>

</style>
